import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const ShippingAndDelivery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <Helmet>
        <title>Shipping & Delivery Policy | Habba Events</title>
        <meta name="description" content="Learn about Habba Events' shipping and delivery policies for our balloon decoration and event services." />
      </Helmet>
      
      <div className="bg-white rounded-lg shadow-xl p-6 md:p-10">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-purple-800">Shipping & Delivery Policy</h1>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Delivery Areas</h2>
            <p className="mb-4">Habba Events provides balloon decoration and event services in Bangalore and surrounding areas. We are committed to ensuring timely and efficient delivery of our services to transform your space for your special occasion.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Delivery Timeframes</h2>
            <p className="mb-4">Our standard delivery and setup times are:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Same-day decoration: We offer same-day decoration services for bookings confirmed before 10:00 AM, subject to availability.</li>
              <li>Standard scheduled bookings: We typically arrive 2-3 hours before your event start time to ensure everything is perfectly set up.</li>
              <li>Large events: For extensive decorations or complex setups, we may schedule the setup a day in advance.</li>
            </ul>
            <p>The exact setup time will be confirmed with you during the booking process.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Delivery Fees</h2>
            <p className="mb-4">Delivery fees vary based on:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Distance from our location in Laggere, Bangalore</li>
              <li>Size and complexity of the decoration</li>
              <li>Specific delivery requirements</li>
            </ul>
            <p>The exact delivery fee will be calculated and displayed during the checkout process.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Delivery Confirmation</h2>
            <p className="mb-4">Once your booking is confirmed, you will receive:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>A booking confirmation email with all details</li>
              <li>A call from our team 24 hours before the scheduled setup</li>
              <li>Contact information for the delivery team</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Rescheduling and Cancellations</h2>
            <p className="mb-4">We understand that plans may change. Our cancellation policy is as follows:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Cancellations made 48 hours or more before the scheduled booking time are eligible for a full refund</li>
              <li>Cancellations made between 24-48 hours before the scheduled booking time are eligible for a 50% refund</li>
              <li>Cancellations made less than 24 hours before the scheduled booking time are not eligible for a refund</li>
            </ul>
            <p>Please refer to our <a href="/refund-policy" className="text-blue-600 hover:underline">Refund Policy</a> for more detailed information on rescheduling and cancellations.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-pink-600">Contact Us</h2>
            <p className="mb-4">If you have any questions about our shipping and delivery policy, please don't hesitate to contact us:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Email: <a href="mailto:habbaeventsblr@gmail.com" className="text-blue-600 hover:underline">habbaeventsblr@gmail.com</a></li>
              <li>Phone: <a href="tel:+918970144660" className="text-blue-600 hover:underline">+918970144660</a></li>
              <li>Address: 184/A, 2nd main road, 4th cross, chowdeshwari nagar, laggere, Bangalore - 560058</li>
              <li>Our <a href="/contact" className="text-blue-600 hover:underline">Contact Page</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ShippingAndDelivery; 